import Stack from 'src/app/atoms/Layout/Stack/Stack';
import { cssVar, mediaQuery } from 'src/app/styles/helper';
import styled, { css } from 'styled-components';

export const FooterFormContainer = styled(Stack)`
  height: 100%;
  flex: 0 1 400px;
  box-shadow: ${cssVar('shadow-xs')};

  ${mediaQuery(
    'lg',
    css`
      flex: 1 1 100%;
    `
  )}
`;

export const FooterHubspotForm = styled.div`
  position: relative;
  display: grid;
  min-height: 85px;

  .hs-form-required {
    display: none;
  }

  > form {
    fieldset {
      display: grid;
      row-gap: ${cssVar('spacing-lg')};
      max-width: unset;

      div.legal-consent-container {
        display: none;
      }

      div.hs-form-field {
        width: 100% !important;
        float: none !important;
      }

      legend.hs-field-desc {
        display: none !important;
      }

      div.input {
        width: 100%;
        background: ${cssVar('bg-primary')};
        border-radius: ${cssVar('radius-md')};
        padding: ${cssVar('spacing-md')} ${cssVar('spacing-lg')};
        box-sizing: border-box;

        input {
          width: 100%;
          background: transparent;
          border: none;
          outline: none;
          color: ${cssVar('text-primary')};
          font-size: ${cssVar('font-size-text-md')};
          font-family: ${cssVar('font-family-body')};
          font-weight: ${cssVar('font-weight-medium')};
          line-height: ${cssVar('line-height-text-md')};
          appearance: none;
          -webkit-appearance: none;
          -moz-appearance: none;

          &::placeholder {
            color: ${cssVar('text-placeholder')};
          }
        }
      }
    }

    .hs-error-msgs {
      color: ${cssVar('text-error-primary')};
      margin: 0.25rem;
      font-size: 0.75rem;
      padding-left: 0rem;
      list-style: none;
    }

    input[type='submit'] {
      display: none;
    }
  }
`;
